import React, { useEffect, useState } from 'react';
import { apiClient } from '../../services/apiClient';

/**
 * Loads pipeline quick-capture images with Bearer auth (img src cannot send Authorization).
 */
const AuthenticatedCaptureImage: React.FC<{
  clientId: string;
  alt: string;
  className?: string;
}> = ({ clientId, alt, className }) => {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;
    (async () => {
      try {
        const blob = await apiClient.fetchAuthorizedBlob(`clients/${clientId}/capture-image/`);
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      } catch {
        if (!cancelled) setSrc(null);
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [clientId]);

  if (!src) {
    return (
      <div
        className={`animate-pulse rounded-lg bg-surface-muted ${className ?? ''}`}
        aria-hidden
      />
    );
  }

  return <img src={src} alt={alt} className={`rounded-lg object-cover ${className ?? ''}`} />;
};

export default AuthenticatedCaptureImage;
